import { memo } from "react"
import "../index.scss";
import CustomScroll from '@src/component/customScroll';
import moment from "moment";
import BottomIcon from "@src/component/bottomIcon";
import Store from "@src/util/store";
import failIcon from "@src/assets/image/rzIndex/fail.png"

const StateSucc = (props: any) => {

  const phone = Store.get('phone').value;

  return (
    <div className="page bottomFit rzStatus">
      <CustomScroll>
        <div className="reRefuse">
          <img src={failIcon} alt="" />
          <div>
            <p><div style={{width: 300}}>抱歉，您当前{props.type?'分期申请':'资格预审'}未通过，暂无法向您提供金融服务</div>
            您可在{moment(Number(props.assessTime)).add(props.type?30:60, 'days').format('yyyy-MM-DD')}重新发起申请</p>
          </div>
        </div>
      </CustomScroll>
      <p className="yw">若有疑问，请联系：<span onClick={()=> {location.href = `tel:${phone as string}`}}>{phone}</span></p>
      <BottomIcon></BottomIcon>
    </div>

  )
}

export default memo(StateSucc);